import { Outlet } from "react-router-dom";

import { Sidebar } from "@/widgets/Sidebar";

/**
 * Главный shell приложения: фиксированный сайдбар слева + контент справа.
 * На мобайле сайдбар прячется (sm:flex). Полноценный мобильный navigation
 * (Sheet) добавим во второй фазе блока 09 — сейчас фокус на десктопе.
 */
export function Layout(): JSX.Element {
  return (
    <div className="relative flex min-h-screen bg-background text-foreground">
      {/* ambient glow blobs за всем контентом */}
      <div
        className="glow-blob"
        style={{ left: "20%", top: "10%", width: 600, height: 600, background: "rgba(139,92,246,0.10)" }}
      />
      <div
        className="glow-blob"
        style={{ right: "0%", top: "40%", width: 500, height: 500, background: "rgba(6,182,212,0.08)" }}
      />

      <div className="hidden sm:block">
        <Sidebar />
      </div>

      <main className="relative z-10 min-w-0 flex-1 px-4 py-6 sm:px-10 sm:py-8">
        <Outlet />
      </main>
    </div>
  );
}
